import { useMemo } from '@web-stories-wp/react';
import { sanitizeRichText } from '../../../utils/sanitizeMarkup';

export function getSanitizedTextElement(element) {
  const content = sanitizeRichText(element?.content);
  return content === element?.content ? element : { ...element, content };
}

export default function useSanitizedTextElement(element) {
  const content = useMemo(
    () => sanitizeRichText(element?.content),
    [element?.content]
  );
  return useMemo(
    () => (content === element?.content ? element : { ...element, content }),
    [content, element]
  );
}
